import classes from './index.module.scss';
import BackButton from '@core/components/backbutton/BackButton';
import Form from 'components/pages/contact-us/Form';

import { NextSeo } from 'next-seo';
import { getContactUsSeoProps } from 'router/seoprops';

const ContactUs = () => {
	const seoProps = getContactUsSeoProps();
	return (
		<>
			<NextSeo {...seoProps} />
			<div className="container col-12 col-xl-8">
				<div className={`${classes['title-container']} d-none d-xl-flex flex-row`}>
					<BackButton type="bordered" />
					<div className={`${classes['page-title']}`}>Contact Us</div>
				</div>
				<Form />
			</div>
		</>
	);
};

export default ContactUs;
